<template>
  <div class="xl:px-32 lg:px-20 md:px-14 px-10 bg-white">
    <h2
      class="md:text-3xl sm:text-2xl text-xl bg-white font-bold text-center text-[#006]"
    >
      ¿Qué es el PROCESA?
    </h2>
    <div
      class="flex md:flex-row flex-col justify-evenly items-center pb-10 border-b-2 border-[#00BFFF]"
    >
      <img
        src="../../assets/home/ilustracion2.svg"
        alt="ilustracion1"
        class="md:w-2/5 w-full"
      />
      <div class="md:w-2/5 w-full text-black flex flex-col items-center">
        <p
          class="pb-8 pl-4 font-normal md:text-lg sm:text-base text-sm text-justify"
        >
          Es un encuentro en donde se promueve la ingeniería química y carreras
          afines junto a líderes del Instituto Norteamericano de Ingenieros
          Químicos (AIChE, por sus siglas en inglés), estudiantes de diferentes
          universidades, investigadores y profesionales de la industria de
          Latinoamérica Hispanohablante. Es un espacio en donde se realizan
          conferencias magistrales, talleres, competencias oficiales, espacios
          de networking, eventos culturales y mucho más.
        </p>
        <h3 class="text-lg font-bold">
          <span
            class="mb-4 mr-4 bg-[#006] text-white rounded-full inline-block text-center w-8 h-8 p-0.5 shadow-xl shadow-[#006]/25"
            >~</span
          >Fecha de Realización:
        </h3>
        <p class="font-semibold">4 al 6 de Agosto del 2022</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
